// Native
import { Box, Flex, HStack, Text } from "@chakra-ui/react"

// Custom
import { UI } from "components"
import { Styles } from "config"
import useUser from "hooks/useUser"

export default function(props){

    const user = useUser()
    const consultant = user.data?.consultant
    const status = Styles.activeMonth(consultant?.active_month_status)

    return(
    <UI.Box loading={user.isLoading} colorPalette={status.colorPalette} {...props}>
        <Flex h="100%" alignItems="center" justifyContent="center">
            <HStack gap={4}>
                <UI.Avatar backgroundColor={status.colorPalette} icon={<UI.Icon name={status.icon} />} />
                <Box>
                    <Text children={consultant?.active_month_status_label} fontSize="lg" fontWeight="bold" color={status.colorPalette + '.fg'} />
                    <Text children={status.description} fontSize="xs" color={status.colorPalette + '.fg'} />
                </Box>
            </HStack>
        </Flex>
    </UI.Box>
    )
}